import { MEDIA_TYPE_VIDEO } from './consts';
import getMediaType from './getMediaType';

const isMediaOfVideoFormat = (resource) => getMediaType(resource) === MEDIA_TYPE_VIDEO;

export default isMediaOfVideoFormat;
